import {
  EMPLOYER_USER,
  JOB_SEEKER_USER,
} from "../../app/firestore/firebaseService";

export function getUserState(currentUserAccount) {
  if (!currentUserAccount) {
    return "N/A";
  } else if (currentUserAccount.type === EMPLOYER_USER) {
    return "Employer";
  } else if (currentUserAccount.type === JOB_SEEKER_USER) {
    return "Job Seeker";
  } else if (currentUserAccount.type === "adminUser") {
    return "Admin";
  }
}
